import { createUrl } from './utils'
import shareLogo from '../assets/ampparit-share-logo.png'

const website = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'url': createUrl('/'),
  'potentialAction': {
    '@type': 'SearchAction',
    'target': createUrl('/haku') + '?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
}

const organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'url': createUrl('/'),
  'logo': shareLogo,
  'sameAs': [
    'https://www.facebook.com/ampparit/',
    'https://twitter.com/ampparitcom',
    'https://x.com/ampparitcom',
  ],
  'email': 'ampparit@ampparit.com',
}

const postalAddress = {
  '@context': 'https://schema.org',
  '@type': 'PostalAddress',
  'addressCountry': 'FI',
  'addressLocality': 'Helsinki',
  'name': 'Alma Media Oyj',
  'postalCode': '00101',
  'streetAddress': 'Alma-talo, Alvar Aallon katu 3 C',
}

/*
TODO: add everything required from https://developers.google.com/search/docs/appearance/structured-data/software-app
const iosApp = {
  '@context': 'https://schema.org',
  '@type': 'MobileApplication',
  'applicationCategory': 'BrowserApplication',
  'applicationSubCategory': 'News & Magazines',
  'genre': 'News & Magazines',
  'name': 'Ampparit',
  'description': 'Ampparit.com on Suomen suosituin uutisportaali, joka kokoaa yhteen uutiset ja artikkelit eri medioista. Se tarjoaa ajankohtaiset uutiset eri aihealueilta, kuten politiikka, talous, urheilu ja viihde.',
  'operatingSystem': 'iOS',
  'installUrl': 'https://apps.apple.com/us/app/uutiset-ampparit-com/id673931936',
  'offers': {
    '@type': 'Offer',
    'price': 0,
    'priceCurrency': 'EUR',
    'url': 'https://apps.apple.com/us/app/uutiset-ampparit-com/id673931936',
  },
}

const androidApp = {
}
*/


const prettyPrint = (obj) => '\n' + JSON.stringify(obj, null, 2).replaceAll(/^(.)/gm, '      $1')
export const jsonLd = {
  website: prettyPrint(website),
  organization: prettyPrint(organization),
  postalAddress: prettyPrint(postalAddress),
}
